/**
 * TimingPill — a tentpole's timing as a pill. Only a moment that is
 * happening now earns color (the live dot); upcoming ones stay neutral and
 * ended ones go quiet, so the eye lands on what's live.
 */

import React from 'react';
import { StatusPill, StatusVariant } from '../../ui';
import { Tentpole } from './types';
import { tentpoleTiming } from './shared';

const PHASE_VARIANT: Record<'upcoming' | 'live' | 'past', StatusVariant> = {
  live: 'live',
  upcoming: 'draft',
  past: 'paused',
};

const TimingPill: React.FC<{ tentpole: Pick<Tentpole, 'startDate' | 'endDate'> }> = ({ tentpole }) => {
  const { label, phase } = tentpoleTiming(tentpole);
  return (
    <StatusPill
      variant={PHASE_VARIANT[phase]}
      uppercase={false}
      noDot={phase !== 'live'}
      appearance={phase === 'past' ? 'quiet' : 'filled'}
    >
      {label}
    </StatusPill>
  );
};

export default TimingPill;
